module.exports = __webpack_public_path__ + "static/media/evening-snack.f106b409.jpeg";